import { useEffect, useState } from 'react'
import { getBannerCookie, COOKIE_CHECK_INTERVAL } from '../utils'

export const useBannerCookie = (isProd: boolean, showOnStartup: boolean) => {
  const [bannerCookie, setBannerCookie] = useState<string | undefined>(() => getBannerCookie())

  useEffect(() => {
    if (!showOnStartup || !isProd) return

    const interval = setInterval(() => {
      const current = getBannerCookie()
      if (current !== bannerCookie) {
        setBannerCookie(current)
      }
    }, COOKIE_CHECK_INTERVAL)

    return () => clearInterval(interval)
  }, [bannerCookie, isProd, showOnStartup])

  return bannerCookie
}
